import { DataTableSortStatus } from 'mantine-datatable';

type GetValidSortKeyOptionsType = {
  accessorOptions: string[];
  accessor: DataTableSortStatus['columnAccessor'];
  defaultAccessor: string;
};

export const getValidSortKey = ({
  accessorOptions,
  accessor,
  defaultAccessor,
}: GetValidSortKeyOptionsType): string => {
  const foundAccessor = accessorOptions.find((option) => option === accessor);

  return foundAccessor ?? defaultAccessor;
};
